import React from 'react';

// ============================================================================
// StatusText — inline colored-ink status · CP0 §A4 / §A6
// ----------------------------------------------------------------------------
// The single biggest de-badging lever: for soft, in-row signals (an overdue
// date in danger ink, a positive ADG in ok ink, a "low" count in warn ink),
// prefer colored TEXT over a pill. Reserve <Badge> for true lifecycle state.
//
//   tone ∈ { ok, warn, danger, info, muted }   (default: muted)
//
// Colors are the Table A inks from the Design Constitution tokens (:root).
// `muted` is the secondary gray for non-signal text. Color is never the only
// signal: the text itself carries the word (§7, D05).
// ============================================================================

const TONES = {
  ok: 'var(--ok-ink)',
  warn: 'var(--warn-ink)',
  danger: 'var(--danger-ink)',
  info: 'var(--info-ink)',
  muted: 'var(--text-2)',
};

// Closed tone set, same reasoning as Badge's variant: the union is the real
// contract and `|| TONES.muted` remains the runtime guard for JavaScript callers.
export type StatusTone = keyof typeof TONES;

type StatusTextProps = {
  tone?: StatusTone;
  children?: React.ReactNode;
  title?: string;
  style?: React.CSSProperties;
};

export default function StatusText({tone = 'muted', children, title, style}: StatusTextProps) {
  const color = TONES[tone] || TONES.muted;
  return (
    <span data-status-text={tone} title={title} style={{color, fontWeight: 600, ...style}}>
      {children}
    </span>
  );
}

export const STATUS_TONES = Object.keys(TONES);
